import React from 'react';
import { SectionPanel } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import {
  AddFiltersHandler, DeleteAllFiltersHandler,
  DeleteFilterHandler, UpdateFilterHandler
} from 'app/area/shared/default-filters/types';
import { DefaultFilter, DefaultFilterValidation, DefaultFilterMetadata } from 'app/area/shared/default-filters/types-store';
import { DefaultFilters } from 'app/area/shared/default-filters/components/default-filters';
import { DashboardSectionType } from '../metroline/types';
import { DashboardAdminTranslation } from '../../constants';
import { defaultFilterDashboardConfig } from '../constants';
import { endpoints } from '../endpoints';

interface DashboardFiltersProps extends WithMetroLineWrappedComponentProps<DashboardSectionType> {
  filters: DefaultFilter[];
  filterMetadata: { [domain: number]: DefaultFilterMetadata };

  addFilters: AddFiltersHandler;
  updateFilter: UpdateFilterHandler;
  deleteFilter: DeleteFilterHandler;
  deleteAllFilters: DeleteAllFiltersHandler;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;

  filterValidation: { [domainId: number]: DefaultFilterValidation };
  translation: DashboardAdminTranslation;

  section: string;
}

export const DashboardFilters: React.FC<DashboardFiltersProps> = ({
  filters, filterMetadata,
  addFilters, updateFilter, deleteFilter, deleteAllFilters,
  options, loadOptions,
  locale, filterValidation, translation,
  section, getRef, shouldRenderSection
}) => {

  return <MetroLineSection<DashboardSectionType>
    section={section}
    sectionType={DashboardSectionType.Filters}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(DashboardSectionType.Filters)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={DashboardSectionType.Filters}
        validation={undefined}
        label={{ visible: true, text: translation.filters }}
        info={{ visible: true, text: translation.filters_info }} />
      <DefaultFilters
        filters={filters}
        filterMetadata={filterMetadata}
        addFilters={addFilters}
        updateFilter={updateFilter}
        deleteFilter={deleteFilter}
        deleteAllFilters={deleteAllFilters}
        config={defaultFilterDashboardConfig}
        endpoints={endpoints}
        options={options}
        loadOptions={loadOptions}
        locale={locale}
        filterValidation={filterValidation}
        translation={translation} />
    </div>
  </MetroLineSection>;
};
